import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'analytics';

export const CLEAR_SELECTED_FILTERS = `${NAMESPACE}/CLEAR_SELECTED_FILTERS`;
export const SELECT_FILTER_ITEMS = `${NAMESPACE}/SELECT_FILTER_ITEMS`;
export const SELECT_DATE_FILTER = `${NAMESPACE}/SELECT_DATE_FILTER`;
export const REMOVE_FILTER_ITEM = `${NAMESPACE}/REMOVE_FILTER_ITEM`;
export const SET_FILTER_ITEMS = `${NAMESPACE}/SET_FILTER_ITEMS`;
export const SET_FILTERS_FROM_QUERY_PARAMS = `${NAMESPACE}/SET_FILTERS_FROM_QUERY_PARAMS`;

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const GET_FILTERS = createApiNamespacedConstants('GET_FILTERS');

// errors
export const ERROR_FAILED_GET_TESTS = 'failed to load tests';
export const ERROR_FAILED_LOAD_METRICS = 'failed to load test metrics';
export const ERROR_FAILED_LOAD_ORGANIZATION = 'failed to load organization';
